import { render, staticRenderFns } from "./LogInForm.vue?vue&type=template&id=51857980"
import script from "./LogInForm.vue?vue&type=script&lang=js"
export * from "./LogInForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports